module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/cost-1135258cbc14387328434b062e51998f.svg";